/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 * Also mutations MUST BE SYNCHRONOUS https://vuex.vuejs.org/guide/mutations.html#mutations-must-be-synchronous
 */
import * as types from "./types";

const mutations = {
  [types.SET_SECOND_COMPONENT_FLOW](state, payload) {
    state.secondComponentFlow = payload;
  },
  [types.SET_USE_SECOND_VIEW](state, payload) {
    state.useSecondView = payload;
  },
  [types.SET_IMAGE_CATEGORY](state, payload) {
    state.image_category = payload;
  },
  [types.SET_SELECTED_IMAGE](state, {componentName, category = null, ugcObject}) {
    const ugc = {...ugcObject};
    ugc.category = category ?? state.image_category;
    state.selectedImages = {
      ...state.selectedImages,
      [componentName]: ugc
    };
  },
  [types.CLEAR_COMPONENT_SELECTED_IMAGE](state, {componentName}) {
    delete state.selectedImages[componentName];
  },
  [types.CLEAR_SELECTED_IMAGES](state) {
    state.selectedImages = null;
  },
  [types.SET_COMPONENT_CURRENT_IMAGE](state, {componentName, category, ugcObject}) {
    state.currentImages = {
      ...state.currentImages,
      [componentName]: {
        category,
        ugc: ugcObject
      }
    };
  },
  [types.SET_LIBRARY_RECIPE](state, data) {
    state.storageController.recipe = {
      ...data
    };
  },
  [types.UPDATE_LIBRARY_COMPONENT](state, { componentName, data }) {
    if (!state.storageController.recipe?.components?.[componentName]) return false;
    state.storageController.recipe.components = {
      ...state.storageController.recipe.components,
      [componentName]: {
        ...data
      }
    };
  },
  [types.SET_VIEWS](state, views) {
    state.navigation.views = views;
  },
  [types.SET_ACTIVE_VIEW](state, activeView) {
    const { secondComponentFlow, useSecondView } = state;
    let index = [], i = -1;
    while ((i = state.navigation.views.indexOf(activeView, i+1)) != -1) {
      index.push(i);
    }
    if (index.length < 1) return;
    let activeIndex = (useSecondView || secondComponentFlow) ? index[index.length - 1] : index[0];
    if (index && index.length > 2) {
      // For authentic classic design views which has 3
      const item = index.findIndex(elem => elem === state.navigation.activeViewIndex);
      activeIndex = index[item] ?? activeIndex;
    }
    state.navigation.activeViewIndex = activeIndex;
    state.navigation.activeView = activeView;
  },
  [types.PREV_VIEW](state) {
    const index = state.navigation.activeViewIndex - 1;
    if (index < 0 || index >= state.navigation.views.length) {
      throw new Error(`Invalid view index: ${index}`);
    }
    state.navigation.activeViewIndex = index;
    const activeView = state.navigation.views[index];
    this.commit("imageGallery/SET_ACTIVE_VIEW", activeView );
  },
  [types.NEXT_VIEW](state) {
    const index = state.navigation.activeViewIndex + 1;
    if (index < 0 || index >= state.navigation.views.length) {
      throw new Error(`Invalid view index: ${index}`);
    }
    state.navigation.activeViewIndex = index;
    const activeView = state.navigation.views[index];
    this.commit("imageGallery/SET_ACTIVE_VIEW", activeView );
  },
  [types.RESET_NAVIGATION](state) {
    state.navigation = {
      activeView: "",
      activeViewIndex: 0,
      views: []
    };
  },
  [types.SET_IS_BACK_APPLIED](state, payload) {
    state.isBackToLibraryApplied = payload;
  },
  [types.SET_CURRENT_UGC_VIEW](state, payload) {
    state.currentUgcView = payload
  },
  [types.SET_USE_SAME_IMAGE](state, payload) {
    state.useSameImage = payload;
  }
};

export default mutations;
